export const FETCH_CONSTRUCTOR_STANDINGS_REQUEST = "FETCH_CONSTRUCTOR_STANDINGS_REQUEST";
export const FETCH_CONSTRUCTOR_STANDINGS_SUCCESS = "FETCH_CONSTRUCTOR_STANDINGS_SUCCESS";
export const FETCH_CONSTRUCTOR_STANDINGS_FAILURE = "FETCH_CONSTRUCTOR_STANDINGS_FAILURE";

export const FETCH_CONSTRUCTOR_RESULTS_REQUEST = "FETCH_CONSTRUCTOR_RESULTS_REQUEST";
export const FETCH_CONSTRUCTOR_RESULTS_SUCCESS = "FETCH_CONSTRUCTOR_RESULTS_SUCCESS";
export const FETCH_CONSTRUCTOR_RESULTS_FAILURE = "FETCH_CONSTRUCTOR_RESULTS_FAILURE";